import { render, staticRenderFns } from "./cardContent.vue?vue&type=template&id=0b0a4af2&scoped=true&"
import script from "./cardContent.vue?vue&type=script&lang=js&"
export * from "./cardContent.vue?vue&type=script&lang=js&"
import style0 from "./cardContent.vue?vue&type=style&index=0&id=0b0a4af2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0a4af2",
  null
  
)

export default component.exports